<script>
import { Search } from "lucide-vue-next";
import { Input } from "@/shared/ui/input";
import TableFooterWrapper from "@/shared/ui/custom/components/TableFooterWrapper.vue";
import LoggingFilter from "./LoggingFilter.vue";
import dateFormat from "@/shared/lib/date-format";
import { getLogList, exportLogList } from "@/entities/logging";
import { getRoleList } from "@/entities/role";
import Button from "@/shared/ui/button/Button.vue";
import TableRowActions from "@/shared/ui/custom/components/TableRowActions.vue";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/shared/ui/pagination";
import {
  Table,
  TableBody,
  TableCell,
  TableEmpty,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/ui/table";
export default {
  name: "LoggingList",
  components: {
    TableFooterWrapper,
    Search,
    Input,
    LoggingFilter,
    Button,
    TableRowActions,
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationItem,
    PaginationNext,
    PaginationPrevious,
    Table,
    TableBody,
    TableCell,
    TableEmpty,
    TableHead,
    TableHeader,
    TableRow,
  },
  data() {
    return {
      showFilters: false,
      loading: false,
      list: [],
      roles: [],
      total: 0,
      filters: {
        q: "",
        user_q: "",
        page: 1,
        page_size: 20,
        dateRange: [],
      },
      pageSizes: [1, 5, 10, 20],
    };
  },
  computed: {
    actions() {
      return [
        {
          label: "Просмотр лога",
          type: "default",
          action: "view",
          icon: "huge-eye",
        },
      ];
    },
    currentLang() {
      return this.$i18n.locale;
    },
    titleKey() {
      return {
        kk: "name_kz",
        ru: "name",
        en: "name_en",
      }[this.currentLang];
    },
    actionDescriptionKey() {
      return {
        kk: "action_description_kz",
        ru: "action_description",
        en: "action_description_en",
      }[this.currentLang];
    },
  },
  watch: {
    filters: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  created() {
    this.fetchRoles();
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchRoles() {
      try {
        const data = await getRoleList();
        if (data?.payload?.items) {
          this.roles = data.payload.items;
        }
      } catch (e) {
        console.error("Failed fetch roles", e);
      }
    },
    getRoleName(code) {
      if (!code) return this.$t("Не указано");
      const role = this.roles.find((r) => r.code === code);

      return role ? role[this.titleKey] : code;
    },
    async fetchData() {
      let params = this.getParams();

      this.loading = true;

      try {
        let data = await getLogList(params);

        if (data) {
          this.total = data.total || 0;
          if (data.items?.length > 0) {
            this.list = data.items.map((item) => ({
              ...item,
            }));
          } else {
            this.list = [];
          }
        }
      } finally {
        this.loading = false;
      }
    },
    getParams(isExport = false) {
      let params = {};

      if (!isExport) {
        params.limit = this.filters.page_size;
        params.offset = (this.filters.page - 1) * this.filters.page_size;
      }

      const query = (this.filters.q || this.filters.user_q || "").trim();

      if (query) {
        const isOnlyDigits = /^\d+$/.test(query);
        const isOnlyLetters = /^[a-zA-Zа-яА-ЯёЁәіңғүұқөһӘІҢҒҮҰҚӨҺ\s]+$/.test(
          query
        );

        if (isOnlyDigits) {
          params.identifier = query;
        } else if (isOnlyLetters) {
          params.fio = query;
        }
      }

      if (this.filters.dateRange?.length === 2) {
        params.created_at_gte = this.filters.dateRange[0];
        params.created_at_lte = this.filters.dateRange[1];
      }

      return params;
    },
    async handleExport() {
      const params = this.getParams(true);
      try {
        const blob = await exportLogList(params);
        if (!blob) {
          console.error("Файл не получен");
          return;
        }
        const url = window.URL.createObjectURL(
          new Blob([blob], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        const fileName = `logs_${new Date().toISOString().slice(0, 10)}.xlsx`;
        link.setAttribute("download", fileName);
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.error("Export failed", e);
      }
    },
    handlePageChange(page) {
      this.filters.page = page;
    },
    dateFormat(date) {
      if (!date) {
        return null;
      }
      return dateFormat.timestamp_to_local_tz(date, "DD.MM.YYYY HH:mm");
    },
    async handleActions(item) {
      if (item.action === "view") {
        this.$router.push({
          name: "logging_item_view",
          params: { id: item.uuid },
        });
      }
    },

    handleRowClick(row) {
      this.$router.push({
        name: "logging_item_view",
        params: { id: row.id },
      });
    },
    search(source) {
      this.filters.page = 1;
      if (source === "main") {
        this.filters.user_q = "";
      } else if (source === "filter") {
        this.filters.q = "";
      }
    },
    resetFilters() {
      this.filters.dateRange = [];
      this.filters.user_q = "";
      this.filters.q = "";
    },
    handleSelectionChange() {},
    formatFio(fio) {
      if (!fio) return "";
      const parts = fio.trim().split(/\s+/);
      if (parts.length === 0) return "";

      if (parts.length >= 2) {
        const firstName = parts[0];
        const surname = parts[1];
        const patronymic = parts[2];

        const surnameFormatted =
          surname.charAt(0).toUpperCase() + surname.slice(1).toLowerCase();
        const firstInitial = firstName.charAt(0).toUpperCase() + ".";
        const patronymicInitial = patronymic
          ? patronymic.charAt(0).toUpperCase() + "."
          : "";

        return `${surnameFormatted} ${firstInitial}${patronymicInitial}`;
      }

      return parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase();
    },
  },
};
</script>

<template>
  <div class="wrapper-page">
    <div class="main">
      <div class="toolbar">
        <div class="flex items-center gap-4">
          <div class="relative" style="width: 320px">
            <Search
              class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground"
            />
            <Input
              v-model="filters.q"
              :placeholder="$t('Поиск по журналу')"
              class="pl-9"
              @input="search('main')"
            />
          </div>

          <Button
            variant="outline"
            @click="showFilters = !showFilters"
            size="icon"
          >
            <svg-icon
              name="huge-filter"
              class="w-5 h-5 text-muted-foreground"
            />
          </Button>
        </div>
        <Button variant="outline" @click="handleExport">
          <div class="text-foreground">
            {{ $t("Экспорт") }}
          </div>
          <svg-icon name="huge-upload" class="w-4 h-4 ml-2" />
        </Button>
      </div>

      <div class="filter-container">
        <div class="filter-wrapper" :class="{ 'filter-hidden': !showFilters }">
          <LoggingFilter
            v-model="filters"
            @search="search"
            @reset="resetFilters"
          />
        </div>
      </div>

      <div class="table-area">
        <div class="h-full overflow-auto">
          <Table
            class="main-table"
            :loading="loading"
            :scroll-reset-key="filters.page"
          >
            <TableHeader>
              <TableRow>
                <TableHead class="w-[68px]"></TableHead>
                <TableHead class="min-w-[226px]">{{
                  $t("Дата и время действия")
                }}</TableHead>
                <TableHead class="min-w-[212px]">{{
                  $t("Пользователь")
                }}</TableHead>
                <TableHead class="min-w-[113px]">{{ $t("Роль") }}</TableHead>
                <TableHead class="min-w-[161px]">{{
                  $t("Рабочая станция")
                }}</TableHead>
                <TableHead class="min-w-[124px]">Модуль</TableHead>
                <TableHead class="min-w-[246px]">{{
                  $t("Действие")
                }}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableEmpty v-if="!loading && !list.length" :colspan="7">
                {{ $t("Нет данных") }}
              </TableEmpty>
              <TableRow
                v-for="row in list"
                :key="row.id"
                @click="handleRowClick(row)"
              >
                <TableCell @click.stop>
                  <TableRowActions
                    :actions="actions"
                    @action="
                      handleActions({
                        action: $event.action,
                        uuid: row.id,
                        rowData: row,
                      })
                    "
                  />
                </TableCell>

                <TableCell>
                  <div
                    v-if="dateFormat(row.timestamp)"
                    class="text-sm font-medium text-foreground"
                  >
                    {{ dateFormat(row.timestamp) }}
                  </div>
                  <div v-else>{{ $t("Не указано") }}</div>
                </TableCell>

                <TableCell>
                  <div v-if="row.fio?.length" class="flex flex-col">
                    <div class="text-sm font-bold text-foreground">
                      {{ formatFio(row.fio) }}
                    </div>
                    <div class="text-sm font-mediuim text-muted-foreground">
                      <span>{{ $t("ИИН") + " " }}</span>
                      <span class="text-foreground">
                        {{ row.identifier }}
                      </span>
                    </div>
                  </div>
                  <div v-else>{{ $t("Не указано") }}</div>
                </TableCell>

                <TableCell>
                  <div
                    v-if="row.user && row.user.role?.length"
                    class="text-sm font-medium text-foreground"
                  >
                    {{ getRoleName(row.user.role) }}
                  </div>
                  <p v-else>
                    {{ $t("Не указано") }}
                  </p>
                </TableCell>

                <TableCell>
                  <div
                    v-if="row.ip?.length"
                    class="text-sm font-bold text-foreground"
                  >
                    {{ row.ip }}
                  </div>
                  <div v-else>{{ $t("Не указано") }}</div>
                </TableCell>

                <TableCell>
                  <div
                    v-if="row.service?.length"
                    class="text-sm font-medium text-foreground"
                  >
                    {{ row.service }}
                  </div>
                  <div v-else>{{ $t("Не указано") }}</div>
                </TableCell>

                <TableCell>
                  <div
                    v-if="row[actionDescriptionKey]"
                    class="text-sm font-medium text-foreground"
                  >
                    {{ row[actionDescriptionKey] }}
                  </div>
                  <div v-else>{{ $t("Не указано") }}</div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        <TableFooterWrapper
          :total="total"
          v-model:pageSize="filters.page_size"
          v-model:currentPage="filters.page"
          :pageSizes="[1, 5, 10, 20]"
          :page-size="filters.page_size"
        >
          <template #pagination>
            <Pagination
              v-if="total > filters.page_size"
              :total="total"
              :items-per-page="filters.page_size"
              :page="filters.page"
              :sibling-count="1"
              :disabled="loading"
              show-edges
              @update:page="handlePageChange"
            >
              <PaginationContent v-slot="{ items }">
                <PaginationPrevious />
                <template v-for="(item, index) in items" :key="index">
                  <PaginationItem
                    v-if="item.type === 'page'"
                    :value="item.value"
                    :is-active="item.value === filters.page"
                  />
                  <PaginationEllipsis v-else />
                </template>
                <PaginationNext />
              </PaginationContent>
            </Pagination>
          </template>
        </TableFooterWrapper>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<style scoped lang="scss">
.main {
  @apply w-full h-full flex flex-col;

  .toolbar {
    @apply flex justify-between items-center mb-8 gap-5;

    .filter {
      @apply p-[7px] bg-muted rounded outline-none;
      &:active {
        transform: scale(0.98);
      }
    }
  }

  .filter-container {
    @apply overflow-hidden;

    .filter-wrapper {
      @apply mb-8;
      transition: margin-top 0.3s ease, opacity 0.3s ease;
    }
  }

  .filter-wrapper.filter-hidden {
    @apply mt-[-72px] mb-0 opacity-0;
  }
}

.next {
  @apply h-8 flex justify-center items-center p-1 pl-2 gap-4 bg-muted border rounded-lg border-border;
}

.arrow-right {
  @apply h-6 flex justify-center items-center bg-card rounded border border-border cursor-pointer;
  width: 24px !important;

  svg {
    @apply w-3 h-3;
  }
}
</style>
